import { render, staticRenderFns } from "./TwitchFeed.vue?vue&type=template&id=4152899e&"
import script from "./TwitchFeed.vue?vue&type=script&lang=js&"
export * from "./TwitchFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports